import posthog from "posthog-js";
import { useFeatureFlagEnabled } from "posthog-js/react";

export const featureFlags = [
  "is_demo_account",
  "email_variants",
  "unlimited_plan",
  "studio",
] as const;

export type FeatureFlag = (typeof featureFlags)[number];

export function isFeatureFlagEnabled(name: FeatureFlag): boolean {
  return posthog.isFeatureEnabled(name) ?? false;
}

export function useFeatureFlag(name: FeatureFlag): boolean {
  return useFeatureFlagEnabled(name) ?? false;
}
